module.exports = __webpack_public_path__ + "img/featuredartist15 (8).31bf6aa7.jpg";